export default "__VITE_ASSET__92ab259f__"